import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
const _hoisted_1 = ["title"];
const _hoisted_2 = { class: "panel-actions" };
const _hoisted_3 = { class: "panel-body" };
const _hoisted_4 = { class: "list-group list-group-flush" };
const _hoisted_5 = { class: "d-flex align-items-start justify-content-between" };
const _hoisted_6 = { class: "flex-grow-1 me-2" };
const _hoisted_7 = { class: "fw-bold" };
const _hoisted_8 = { class: "small text-muted" };
const _hoisted_9 = { key: 0 };
const _hoisted_10 = { key: 1 };
const _hoisted_11 = { key: 2 };
const _hoisted_12 = { key: 3 };
const _hoisted_13 = { key: 4 };
const _hoisted_14 = { key: 5 };
const _hoisted_15 = { class: "ms-2" };
const _hoisted_16 = {
    key: 0,
    class: "mt-1 d-flex align-items-center"
};
const _hoisted_17 = ["value", "max"];
const _hoisted_18 = { class: "ms-2 small" };
const _hoisted_19 = {
    key: 1,
    class: "current-step mt-1"
};
const _hoisted_20 = ["title"];
const _hoisted_21 = {
    key: 1,
    class: "small text-muted"
};
const _hoisted_22 = {
    key: 2,
    class: "d-flex align-items-center"
};
const _hoisted_23 = ["value", "max"];
const _hoisted_24 = { class: "ms-2 small" };
const _hoisted_25 = {
    key: 2,
    class: "text-danger small mt-1"
};
const _hoisted_26 = {
    key: 3,
    class: "text-muted small mt-1"
};
const _hoisted_27 = ["onClick"];
const _hoisted_28 = ["onClick"];
const _hoisted_29 = ["disabled", "onClick"];
const _hoisted_30 = {
    key: 0,
    class: "panel-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_BackgroundTaskDetailsModal = _resolveComponent("BackgroundTaskDetailsModal");
    return (_openBlock(), _createElementBlock("div", null, [
        (_ctx.tasks.hasTasks && _ctx.tasks.panelOpen)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(['progress-panel-draggable', { shifted: _ctx.shifted }]),
                style: _normalizeStyle(_ctx.panelStyle),
                onMousedown: _cache[4] || (_cache[4] = _withModifiers(
                //@ts-ignore
                (...args) => (_ctx.bringToFront && _ctx.bringToFront(...args)), ["self"])),
                ref: "panel"
            }, [
                _createElementVNode("div", {
                    class: "panel-header",
                    onMousedown: _cache[2] || (_cache[2] =
                        //@ts-ignore
                        (...args) => (_ctx.startDrag && _ctx.startDrag(...args)))
                }, [
                    _createElementVNode("span", null, [
                        _cache[6] || (_cache[6] = _createElementVNode("i", { class: "fa fa-tasks me-2" }, null, -1 /* CACHED */)),
                        _cache[7] || (_cache[7] = _createTextVNode("Background tasks\r\n\t\t\t\t\t", -1 /* CACHED */)),
                        (_ctx.tasks.activeCount > 0)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: "message-count",
                                title: `${_ctx.tasks.activeCount} running`
                            }, [
                                _cache[5] || (_cache[5] = _createElementVNode("i", { class: "fa fa-spinner fa-spin me-1" }, null, -1 /* CACHED */)),
                                _createTextVNode(_toDisplayString(_ctx.tasks.activeCount), 1 /* TEXT */)
                            ], 8 /* PROPS */, _hoisted_1))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _cache[9] || (_cache[9] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("button", {
                            class: "close-btn",
                            onClick: _cache[0] || (_cache[0] = _withModifiers(
                            //@ts-ignore
                            (...args) => (_ctx.closePanel && _ctx.closePanel(...args)), ["stop"])),
                            onMousedown: _cache[1] || (_cache[1] = _withModifiers(() => { }, ["stop"])),
                            title: "Close (tasks keep running)",
                            "aria-label": "Close"
                        }, [...(_cache[8] || (_cache[8] = [
                                _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* CACHED */)
                            ]))], 32 /* NEED_HYDRATION */)
                    ])
                ], 32 /* NEED_HYDRATION */),
                _cache[32] || (_cache[32] = _createTextVNode()),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("ul", _hoisted_4, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tasks.messages, (msg) => {
                            return (_openBlock(), _createElementBlock("li", {
                                key: msg.id,
                                class: _normalizeClass(["list-group-item", _ctx.statusClass(msg.status)])
                            }, [
                                _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("div", _hoisted_6, [
                                        _createElementVNode("div", _hoisted_7, _toDisplayString(msg.processName), 1 /* TEXT */),
                                        _cache[22] || (_cache[22] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_8, [
                                            (msg.status === _ctx.statuses.Queued)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_9, [...(_cache[10] || (_cache[10] = [
                                                        _createElementVNode("i", { class: "fa fa-clock-o me-1" }, null, -1 /* CACHED */),
                                                        _createTextVNode("Waiting to start", -1 /* CACHED */)
                                                    ]))]))
                                                : (msg.status === _ctx.statuses.Running)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, [...(_cache[11] || (_cache[11] = [
                                                            _createElementVNode("i", { class: "fa fa-spinner fa-spin me-1" }, null, -1 /* CACHED */),
                                                            _createTextVNode("Running", -1 /* CACHED */)
                                                        ]))]))
                                                    : (msg.status === _ctx.statuses.Completed)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, [...(_cache[12] || (_cache[12] = [
                                                                _createElementVNode("i", { class: "fa fa-check-circle text-success me-1" }, null, -1 /* CACHED */),
                                                                _createTextVNode("Completed", -1 /* CACHED */)
                                                            ]))]))
                                                        : (msg.status === _ctx.statuses.CompletedWithErrors)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_12, [...(_cache[13] || (_cache[13] = [
                                                                    _createElementVNode("i", { class: "fa fa-exclamation-triangle text-warning me-1" }, null, -1 /* CACHED */),
                                                                    _createTextVNode("Completed with problems", -1 /* CACHED */)
                                                                ]))]))
                                                            : (msg.status === _ctx.statuses.Error)
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_13, [...(_cache[14] || (_cache[14] = [
                                                                        _createElementVNode("i", { class: "fa fa-exclamation-circle text-danger me-1" }, null, -1 /* CACHED */),
                                                                        _createTextVNode("Failed", -1 /* CACHED */)
                                                                    ]))]))
                                                                : (msg.status === _ctx.statuses.Cancelled)
                                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, [...(_cache[15] || (_cache[15] = [
                                                                            _createElementVNode("i", { class: "fa fa-ban text-secondary me-1" }, null, -1 /* CACHED */),
                                                                            _createTextVNode("Cancelled", -1 /* CACHED */)
                                                                        ]))]))
                                                                    : _createCommentVNode("v-if", true),
                                            _cache[16] || (_cache[16] = _createTextVNode()),
                                            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.formatDuration(msg.startedAt, msg.endedAt)), 1 /* TEXT */)
                                        ]),
                                        _cache[23] || (_cache[23] = _createTextVNode()),
                                        _createCommentVNode(" Overall: items done of items to do "),
                                        _cache[24] || (_cache[24] = _createTextVNode()),
                                        (msg.progressTotal)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                                _createElementVNode("progress", {
                                                    class: "progress-bar-native flex-grow-1",
                                                    value: msg.progressCurrent || 0,
                                                    max: msg.progressTotal
                                                }, null, 8 /* PROPS */, _hoisted_17),
                                                _cache[17] || (_cache[17] = _createTextVNode()),
                                                _createElementVNode("span", _hoisted_18, _toDisplayString(msg.progressCurrent || 0) + " / " + _toDisplayString(msg.progressTotal), 1 /* TEXT */)
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _cache[25] || (_cache[25] = _createTextVNode()),
                                        _createCommentVNode(" The item being worked on, and what is happening to it "),
                                        _cache[26] || (_cache[26] = _createTextVNode()),
                                        (!_ctx.isFinished(msg) && (msg.currentItem || msg.stepDescription))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                                (msg.currentItem)
                                                    ? (_openBlock(), _createElementBlock("div", {
                                                        key: 0,
                                                        class: "small fw-bold text-truncate",
                                                        title: msg.currentItem
                                                    }, _toDisplayString(msg.currentItem), 9 /* TEXT, PROPS */, _hoisted_20))
                                                    : _createCommentVNode("v-if", true),
                                                _cache[19] || (_cache[19] = _createTextVNode()),
                                                (msg.stepDescription)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(msg.stepDescription), 1 /* TEXT */))
                                                    : _createCommentVNode("v-if", true),
                                                _cache[20] || (_cache[20] = _createTextVNode()),
                                                (msg.stepTotal)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                                        _createElementVNode("progress", {
                                                            class: "progress-bar-native progress-bar-step flex-grow-1",
                                                            value: msg.stepCurrent || 0,
                                                            max: msg.stepTotal
                                                        }, null, 8 /* PROPS */, _hoisted_23),
                                                        _cache[18] || (_cache[18] = _createTextVNode()),
                                                        _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.stepPercent(msg)) + "%", 1 /* TEXT */)
                                                    ]))
                                                    : _createCommentVNode("v-if", true)
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _cache[27] || (_cache[27] = _createTextVNode()),
                                        (msg.errorMessage)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(msg.errorMessage), 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true),
                                        _cache[28] || (_cache[28] = _createTextVNode()),
                                        (_ctx.isCancelling(msg))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [...(_cache[21] || (_cache[21] = [
                                                    _createElementVNode("i", { class: "fa fa-spinner fa-spin me-1" }, null, -1 /* CACHED */),
                                                    _createTextVNode("Cancelling…\r\n\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                ]))]))
                                            : _createCommentVNode("v-if", true),
                                        _cache[29] || (_cache[29] = _createTextVNode()),
                                        (_ctx.hasDetails(msg))
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 4,
                                                type: "button",
                                                class: "btn btn-link btn-sm p-0 mt-1",
                                                onClick: ($event) => (_ctx.openDetails(msg))
                                            }, _toDisplayString(_ctx.isFinished(msg) && msg.errorMessage ? "See what was not done and why" : "View details"), 9 /* TEXT, PROPS */, _hoisted_27))
                                            : _createCommentVNode("v-if", true)
                                    ]),
                                    _cache[31] || (_cache[31] = _createTextVNode()),
                                    (_ctx.isFinished(msg))
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            class: "btn btn-outline-secondary btn-sm",
                                            onClick: ($event) => (_ctx.dismiss(msg.id)),
                                            title: "Dismiss"
                                        }, [...(_cache[30] || (_cache[30] = [
                                                _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* CACHED */)
                                            ]))], 8 /* PROPS */, _hoisted_28))
                                        : (_openBlock(), _createElementBlock("button", {
                                            key: 1,
                                            class: "btn btn-outline-danger btn-sm",
                                            disabled: _ctx.isCancelling(msg),
                                            onClick: ($event) => (_ctx.cancelTask(msg)),
                                            title: "Cancel this task"
                                        }, "\r\n\t\t\t\t\t\t\t\tCancel\r\n\t\t\t\t\t\t\t", 8 /* PROPS */, _hoisted_29))
                                ])
                            ], 2 /* CLASS */));
                        }), 128 /* KEYED_FRAGMENT */))
                    ])
                ]),
                _cache[33] || (_cache[33] = _createTextVNode()),
                (_ctx.finishedCount > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-link btn-sm p-0",
                            onClick: _cache[3] || (_cache[3] =
                                //@ts-ignore
                                (...args) => (_ctx.dismissFinished && _ctx.dismissFinished(...args)))
                        }, "\r\n\t\t\t\t\tClear finished (" + _toDisplayString(_ctx.finishedCount) + ")\r\n\t\t\t\t", 1 /* TEXT */)
                    ]))
                    : _createCommentVNode("v-if", true)
            ], 38 /* CLASS, STYLE, NEED_HYDRATION */))
            : _createCommentVNode("v-if", true),
        _cache[34] || (_cache[34] = _createTextVNode()),
        _createVNode(_component_BackgroundTaskDetailsModal, {
            ref: "taskDetails",
            message: _ctx.selectedMessage
        }, null, 8 /* PROPS */, ["message"])
    ]));
}
